var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialsLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2417",
    "data-name": "Group 2417",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_683",
    "data-name": "Rectangle 683",
    width: 50,
    height: 50,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2417-2",
    "data-name": "Group 2417",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1044",
    "data-name": "Path 1044",
    d: "M44.444,0H5.556A5.556,5.556,0,0,0,0,5.556V44.444A5.556,5.556,0,0,0,5.556,50H44.444A5.556,5.556,0,0,0,50,44.444V5.556A5.556,5.556,0,0,0,44.444,0M15.117,43.056H7.661V18.981h7.456ZM11.353,15.829a4.442,4.442,0,1,1,4.408-4.442,4.426,4.426,0,0,1-4.408,4.442m31.7,27.226H35.636V30.418c0-3.465-1.317-5.4-4.059-5.4-2.983,0-4.542,2.015-4.542,5.4V43.056H19.884V18.981h7.151v3.243a8.4,8.4,0,0,1,7.259-3.978c5.106,0,8.762,3.118,8.762,9.567Z",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialsLinkedin);
export default __webpack_public_path__ + "static/media/socials-linkedin.4b72d424399a60fe0695a67a907bede5.svg";
export { ForwardRef as ReactComponent };